/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { InterventionTechniqueDto } from '../models/intervention-technique-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des interventions techniques
 */
@Injectable({
  providedIn: 'root',
})
export class InterventionsTechniquesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation interventionTechniqueGetList
   */
  static readonly InterventionTechniqueGetListPath = '/api/interventions-techniques/list';

  /**
   * Renvoie la liste des interventions techniques.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionTechniqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionTechniqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<InterventionTechniqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsTechniquesService.InterventionTechniqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InterventionTechniqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des interventions techniques.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionTechniqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionTechniqueGetList(params?: {
  }): Observable<Array<InterventionTechniqueDto>> {

    return this.interventionTechniqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InterventionTechniqueDto>>) => r.body as Array<InterventionTechniqueDto>)
    );
  }

  /**
   * Path part for operation interventionTechniqueLoadList
   */
  static readonly InterventionTechniqueLoadListPath = '/api/interventions-techniques/load-list';

  /**
   * Renvoie la liste des interventions techniques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionTechniqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionTechniqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsTechniquesService.InterventionTechniqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des interventions techniques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionTechniqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionTechniqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.interventionTechniqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation interventionTechniqueGet
   */
  static readonly InterventionTechniqueGetPath = '/api/interventions-techniques/{id}';

  /**
   * Renvoie l'intervention technique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionTechniqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionTechniqueGet$Response(params: {

    /**
     * Identifiant de l&#x27;intervention technique
     */
    id: number;
  }): Observable<StrictHttpResponse<InterventionTechniqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsTechniquesService.InterventionTechniqueGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InterventionTechniqueDto>;
      })
    );
  }

  /**
   * Renvoie l'intervention technique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionTechniqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionTechniqueGet(params: {

    /**
     * Identifiant de l&#x27;intervention technique
     */
    id: number;
  }): Observable<InterventionTechniqueDto> {

    return this.interventionTechniqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<InterventionTechniqueDto>) => r.body as InterventionTechniqueDto)
    );
  }

  /**
   * Path part for operation interventionTechniquePut
   */
  static readonly InterventionTechniquePutPath = '/api/interventions-techniques/{id}';

  /**
   * Met à jour l'intervention technique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionTechniquePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionTechniquePut$Response(params: {

    /**
     * Identifiant de l&#x27;intervention technique à mettre à jour
     */
    id: number;

    /**
     * Intervention technique
     */
    body: InterventionTechniqueDto
  }): Observable<StrictHttpResponse<InterventionTechniqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsTechniquesService.InterventionTechniquePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InterventionTechniqueDto>;
      })
    );
  }

  /**
   * Met à jour l'intervention technique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionTechniquePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionTechniquePut(params: {

    /**
     * Identifiant de l&#x27;intervention technique à mettre à jour
     */
    id: number;

    /**
     * Intervention technique
     */
    body: InterventionTechniqueDto
  }): Observable<InterventionTechniqueDto> {

    return this.interventionTechniquePut$Response(params).pipe(
      map((r: StrictHttpResponse<InterventionTechniqueDto>) => r.body as InterventionTechniqueDto)
    );
  }

  /**
   * Path part for operation interventionTechniqueDelete
   */
  static readonly InterventionTechniqueDeletePath = '/api/interventions-techniques/{id}';

  /**
   * Supprime l'intervention technique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionTechniqueDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionTechniqueDelete$Response(params: {

    /**
     * Identifiant de l&#x27;intervention technique à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsTechniquesService.InterventionTechniqueDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'intervention technique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionTechniqueDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionTechniqueDelete(params: {

    /**
     * Identifiant de l&#x27;intervention technique à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.interventionTechniqueDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation interventionTechniquePost
   */
  static readonly InterventionTechniquePostPath = '/api/interventions-techniques';

  /**
   * Crée l'intervention technique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionTechniquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionTechniquePost$Response(params: {

    /**
     * Intervention technique
     */
    body: InterventionTechniqueDto
  }): Observable<StrictHttpResponse<InterventionTechniqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsTechniquesService.InterventionTechniquePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InterventionTechniqueDto>;
      })
    );
  }

  /**
   * Crée l'intervention technique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionTechniquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionTechniquePost(params: {

    /**
     * Intervention technique
     */
    body: InterventionTechniqueDto
  }): Observable<InterventionTechniqueDto> {

    return this.interventionTechniquePost$Response(params).pipe(
      map((r: StrictHttpResponse<InterventionTechniqueDto>) => r.body as InterventionTechniqueDto)
    );
  }

}
